import type { PatientModel } from '@ctw/shared/api/fhir/models/patient';
import { MAX_OBJECTS_PER_REQUEST, fqsRequestAll } from '@ctw/shared/api/fqs/client';
import {
  type AppointmentGraphqlResponse,
  AppointmentQuery,
} from '@ctw/shared/api/fqs/queries/appointments';
import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import type { GraphQLClient } from 'graphql-request';

export async function fetchAppointments(
  telemetry: ReturnType<typeof useTelemetry>,
  graphqlClient: GraphQLClient,
  patient: PatientModel,
) {
  const { data } = await fqsRequestAll<AppointmentGraphqlResponse>(
    telemetry,
    graphqlClient,
    AppointmentQuery,
    'AppointmentConnection',
    {
      upid: patient.UPID,
      cursor: '',
      first: MAX_OBJECTS_PER_REQUEST,
    },
  );

  return data.AppointmentConnection.edges.map(({ node }) => node);
}
